import React from 'react';
import * as S from './PromptCard.styles';

interface PromptCardProps {
  icon?: React.ReactNode;
  title: string;
  text: string;
  onClick: () => void;
}

const PromptCard: React.FC<PromptCardProps> = ({ icon, title, text, onClick }) => {
  return (
    <S.PromptCardContainer onClick={onClick}>
      <S.PromptIconWrapper>{icon}</S.PromptIconWrapper>
      <S.PromptCardContent>
        <S.PromptText>{title}</S.PromptText>
        <S.PromptSubtext>{text}</S.PromptSubtext>
      </S.PromptCardContent>
    </S.PromptCardContainer>
  );
};

PromptCard.displayName = 'PromptCard';

export default PromptCard;
